import type { AvatarProps } from '@core/Avatar';
import { Avatar } from '@core/Avatar';

type Props = Omit<AvatarProps, 'variant' | 'showBorder'> & {
  size?: AvatarProps['size'];
};

/**
 * Common component to render Avatar
 */
const CardAvatar = ({ size = 24, ...props }: Props) => {
  return <Avatar {...props} showBorder size={size} variant="organization" />;
};

export default CardAvatar;
